import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'sections/authentication/context/UseAuth';
import { getRoleRedirect } from 'utils/getRoleRedirect';

export const PublicRoute = () => {
  const { user } = useAuth();
  if (user?.token) {
    return <Navigate to={'/dashboard'} replace />;
  }

  return <Outlet />;
};
